import { useCustomFetch } from '~/shared/lib/useCustomFetch';
import type {
  EventListItemDTO,
  EventsPaginatedResponse,
} from '~/shared/api/client/events/events.dto';
import {
  CLIENT_API_EVENTS_URL,
  CLIENT_API_SPEAKER_DETAIL_EVENTS_KEY,
} from '~/shared/api/client/events/events.const';

type SpeakerDetailEventsResponse =
  | EventListItemDTO[]
  | EventsPaginatedResponse<EventListItemDTO>;

export function useSpeakerDetailEvents() {
  const { data, status, error } = useCustomFetch<SpeakerDetailEventsResponse>(
    CLIENT_API_EVENTS_URL,
    {
      method: 'GET',
      key: CLIENT_API_SPEAKER_DETAIL_EVENTS_KEY,
      query: {
        page: 1,
        page_size: 3,
        partner_event: false,
        time_filter: 'upcoming',
      },
    },
  );

  const events = computed(() => {
    const value = data.value;
    const items = Array.isArray(value) ? value : (value?.results ?? []);

    return [...items]
      .sort((a, b) => a.start_time.localeCompare(b.start_time))
      .slice(0, 3);
  });

  return { events, status, error };
}
